import { useEffect } from 'react';

import { useAppDispatch } from 'Store';

import type { BreadcrumbItem } from './breadcrumbSlice';
import { setBreadcrumbs } from './breadcrumbSlice';

export const useBreadcrumbs = (items: BreadcrumbItem[]) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbs(items));

    return () => {
      dispatch(setBreadcrumbs([]));
    };
  }, [dispatch, items]);
};
